import { IconographyTypes } from '@genial/icons';
import { Utils } from '@genial/utils';

import { AppMenuItem } from './context';

export const sidebarIcons: Record<string, IconographyTypes.Option> = {
  Cockpit: 'Cockpit',
  ManagementAnalysis: 'ManagementAnalysis',
  AngularFrame_ManagementAnalysis: 'ManagementAnalysis',
  RateManagement: 'RateManagement',
  Customers: 'Clients',
  ReportGenerator: 'InboxUpload',
  AngularFrame_Customers: 'Clients',
  Trading: 'DayTrade',
  AngularFrame_Trading: 'DayTrade',
  AngularFrame_TransactionFlow: 'Movement',
  AngularFrame_Commissions: 'Commission',
  AngularFrame_AccessLevels: 'Permission',
  AngularFrame_FormsAndTerms: 'Terms',
  AngularFrame_Linked: 'Linked',
  AngularFrame_Home: 'HomeLegacy',
  AngularFrame_Dashboard: 'DashboardLegacy',
  AngularFrame_ConsolidatedPortfolio: 'ConsolidatedPortfolioLegacy',
  Home: 'Home',
  Consortium: 'Consortium',
  AdemiconConsortium: 'Consortium',
  InviteLinkPlaceholder: 'Invite',
  FixedFee: 'HandMoneyLinear',
};

export const sidebarFocus: Record<string, string[]> = {
  Cockpit: ['NewApplication', 'OrdersHistory', 'BlockList', 'Resume'],
};

export const signoutMenuItem: AppMenuItem = {
  icon: {
    name: 'Exit',
    size: 'sm',
  },
  label: 'Sair',
  routeName: 'SignOut',
};

export const betaBgColor = Utils.ColorToken.WithOpacity('feedback.error.default', 0.8);
